<template>
<div>
  <p>Relocating ...</p>
</div>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "AuthenticationComplete",
  mounted() {
    this.getToken()
  },
  methods: {
    ...mapActions('auth', ['getToken'])
  }
}
</script>

<style scoped>

</style>
